import React from "react";
import { CommonPageTemplate } from "../common/components/CommonPageTemplate";
import { TimelineSection } from "../common/components/TimelineSection";
import resumeData from "../data/resume.json";
import { MdWork, MdSchool, MdCardMembership, MdStar } from "react-icons/md";
import { Link } from "../common/components/Link";
import { FaFileDownload } from "react-icons/fa";
import { Button } from "../common/components/Button";

// Add new icons here as needed — the JSON just references them by key.
const ICON_MAP: Record<string, React.ElementType> = {
  work: MdWork,
  school: MdSchool,
  certificate: MdCardMembership,
  award: MdStar,
};

export const Resume = () => {
  const palette = [
    "#7C3AED",
    "#DB2777",
    "#F97316",
    "#059669",
    "#0EA5E9",
    "#E11D48",
    "#6366F1",
    "#F43F5E",
  ];

  const colorFromString = (s: string) => {
    let hash = 0;
    for (let i = 0; i < s.length; i++) {
      hash = s.charCodeAt(i) + ((hash << 5) - hash);
    }
    return palette[Math.abs(hash) % palette.length];
  };

  return (
    <CommonPageTemplate
      articleTitle="Resume"
      articleClassName="resume"
      isActive={true}
      icon={
        <Button
          className=" ml-1"
          aria-label="Download raw content"
          title="Download Resume"
          onClick={() => window.open(resumeData.resumeUrl)}
        >
          <FaFileDownload />
        </Button>
      }
    >
      {resumeData.sections.map((section) => {
        const IconComponent = ICON_MAP[section.iconName] || MdWork;
        return (
          <TimelineSection
            key={section.id}
            icon={<IconComponent size={20} />}
            sectionTitle={section.title}
            timelineItems={section.items}
          />
        );
      })}

      <section className="skill">
        <h3 className="h3 skills-title">My skills</h3>
        <div className="skills-box">
          {
            // Support new categorized format: [{ category, items: ["skill1", ...] }, ...]
            Array.isArray((resumeData as any).skills) &&
            (resumeData as any).skills.length &&
            (resumeData as any).skills[0].category
              ? (resumeData as any).skills.map((cat: any) => (
                  <div key={cat.category} className="skills-category">
                    <h4>{cat.category}</h4>
                    <div className="skills-category-items">
                      {cat.items.map((s: string) => (
                        <span
                          key={s}
                          className="skill-tag"
                          style={{
                            // set CSS custom property for color so styles live in SCSS
                            ["--tag-color" as any]: colorFromString(s),
                          }}
                        >
                          {s}
                        </span>
                      ))}
                    </div>
                  </div>
                ))
              : // Fallback: legacy format where skills are objects with URL/imgSrc/title
                (resumeData as any).skills.map((skill: any) => (
                  <Link
                    link={skill.URL}
                    newTab
                    rel="noreferrer"
                    key={skill.title}
                    hoverEffect={false}
                    title={skill.title}
                  >
                    <img
                      src={skill.imgSrc}
                      width="48"
                      height="48"
                      alt={skill.title}
                    />
                  </Link>
                ))
          }
        </div>
      </section>
    </CommonPageTemplate>
  );
};
